
<dx-tab-panel class="tab-list" [dataSource]="tabDataSource" [selectedIndex]="tabSelectedIndex" (onSelectionChanged)="OnTabSelectionChanged($event)" (onTitleClick)="onTitleClick($event)"></dx-tab-panel>
<div class="tab-details">
  <div [class.hidden]="tabSelectedIndex !== 0">
    <div class="content-with-padding">
      <div>
        <div class="mat-elevation-z3">
          <div class="one-col-grid">
            <dx-data-grid id="gridContainer"
                          [dataSource]="listOfAffiliatedDocuments"
                          [showRowLines]="true"
                          [showColumnLines]="false"
                          [showBorders]="true"
                          (onRowPrepared)="onRowPrepared($event)"
                          (onRowClick)="clickOnDocument($event)">
              <dxo-selection mode="single"></dxo-selection>
              <dxo-sorting mode="multiple"></dxo-sorting>
              <dxo-paging [pageSize]="10"> </dxo-paging>
              <dxo-search-panel [visible]="false"></dxo-search-panel>
              <dxi-column caption="" cellTemplate="thumbNailTemplate" width="50px"></dxi-column>
              <dxi-column [caption]="labels.Name" [calculateCellValue]="sortByName" [allowSorting]="true" width="50%" cellTemplate="documentTemplate"></dxi-column>
              <dxi-column [caption]="labels.Number" [allowSorting]="true" dataField="Number" [allowHeaderFiltering]="false"></dxi-column>
              <dxi-column [caption]="labels.Type" dataField="DocumentTypeName"></dxi-column>
              <dxo-header-filter visible="true"></dxo-header-filter>
              <div *dxTemplate="let d of 'thumbNailTemplate'">
                <div><img #imglogo style="display:table-cell; height: 50px; max-width: 50px; cursor: pointer;" src="{{d.data.FileThumb}}" /></div>
              </div>
              <div *dxTemplate="let d of 'documentTemplate'">
                <div>{{ d.data.Name }}</div>
                <div>{{ d.data.Description }}</div>
              </div>
            </dx-data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [class.hidden]="tabSelectedIndex !== 1">
    <div class="content-with-padding">
      <div>
        <div class="mat-elevation-z3">
          <div class="one-col-grid">
            <dx-data-grid id="gridContainer"
                          [dataSource]="listOfFavoriteDocuments"
                          [showRowLines]="true"
                          [showColumnLines]="false"
                          [showBorders]="true"
                          (onRowPrepared)="onRowPrepared($event)"
                          (onRowClick)="clickOnDocument($event)">
              <dxo-selection mode="single"></dxo-selection>
              <dxo-sorting mode="multiple"></dxo-sorting>
              <dxo-paging [pageSize]="10"> </dxo-paging>
              <dxo-search-panel [visible]="false"></dxo-search-panel>
              <dxi-column caption="" cellTemplate="thumbNailTemplate" width="50px"></dxi-column>
              <dxi-column [caption]="labels.Name" [calculateCellValue]="sortByName" [allowSorting]="true" width="50%" cellTemplate="documentTemplate"></dxi-column>
              <dxi-column [caption]="labels.Number" [allowSorting]="true" dataField="Number" [allowHeaderFiltering]="false"></dxi-column>
              <dxi-column [caption]="labels.Type" dataField="DocumentTypeName"></dxi-column>
              <dxo-header-filter visible="true"></dxo-header-filter>
              <div *dxTemplate="let d of 'thumbNailTemplate'">
                <div><img #imglogo style="display:table-cell; height: 50px; max-width: 50px; cursor: pointer;" src="{{d.data.FileThumb}}" /></div>
              </div>
              <div *dxTemplate="let d of 'documentTemplate'">
                <div>{{ d.data.Name }}</div>
                <div>{{ d.data.Description }}</div>
              </div>
            </dx-data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [class.hidden]="tabSelectedIndex !== 2">
    <div class="content-with-padding">
      <div class="search-grid-wrapper">
        <app-elevation-section [title]="labels.searchParameters">
          <table>
            <tbody>
              <tr>
                <td colspan="2">
                  <app-basic-search [documentTypes]="documentTypes"
                                    [documentCategories]="documentCategories"
                                    [documentTypeSearchValue]="documentTypeSearchValue"
                                    [documentCategorySearchValue]="documentCategorySearchValue">
                  </app-basic-search>
                </td>
              </tr>
              <tr>
                <td>

                  <dx-button stylingMode="outlined"
                             [text]="labels.search"
                             type="normal"
                             [width]="100"
                             icon="search"
                             (onClick)="onSearchClick()">
                  </dx-button>
                </td>
                <td colspan="2">
                  <dx-button stylingMode="outlined"
                             [text]="labels.clear"
                             type="normal"
                             [width]="150"
                             icon="clearformat"
                             (onClick)="onClearSearchClick()">
                  </dx-button>
                </td>
              </tr>
            </tbody>
          </table>
        </app-elevation-section>
        <app-elevation-section [title]="labels.searchResult">
          <div class="drawer-menu-right" style="padding: 16px, 16px, 16px, 16px; width: auto">
            <app-document-operator-search-detail [dataSource]="listOfSearchResults" (rowClicked)="openTab($event)" (loading)="isLoading=$event">
            </app-document-operator-search-detail>
          </div>
        </app-elevation-section>
      </div>
    </div>
  </div>
  <div *ngIf="tabSelectedIndex > 2">
    <app-document-operator-document-card [documentId]="tabDataSource[tabSelectedIndex].id"
                                         [documentTypes]="documentTypes"
                                         [documentCategories]="documentCategories"
                                         (documentAdded)="setLookups()"
                                         (closeTab)="onCloseCard()"
                                         (loading)="isLoading=$event">
    </app-document-operator-document-card>
  </div>
</div>

